import React from 'react'

import IconMessage from './IconMessage'

const ErrorMessage = (props) => (
  <IconMessage
    icon={'report'}
    {...props}
  />
)

export default ErrorMessage